import { Button } from "@/components/ui/button";

interface DrawerFooterProps {
  editing: boolean;
  dirty: boolean;
  status: string;
  /** The edit area's form id; Save submits it. */
  formId: string;
  saving?: boolean;
  /** Drafts only; disabled with a reason when the draft can't be deleted. */
  onDeleteDraft?: () => void;
  deleteDisabled?: boolean;
  onDiscard: () => void;
  /** "Done" on a non-draft: leaves edit mode. */
  onDone: () => void;
  onClose: () => void;
}

/**
 * The drawer's footer (#1559). `pr-[84px]` keeps Save clear of the floating
 * feedback button (#708; the SocialSettingsDrawer precedent).
 */
export function DrawerFooter({
  editing, dirty, status, formId, saving, onDeleteDraft, deleteDisabled, onDiscard, onDone, onClose,
}: DrawerFooterProps) {
  const draft = status === "draft";
  return (
    <div className="flex flex-wrap items-center justify-between gap-2 border-t bg-card px-5 py-2.5 max-[760px]:sticky max-[760px]:bottom-0 max-[760px]:z-10 pr-[84px] pb-[calc(10px+env(safe-area-inset-bottom,0px))] max-[760px]:pl-4">
      {editing ? (
        <>
          {dirty ? (
            <span className="text-[13px] font-semibold text-status-warn">● Unsaved changes</span>
          ) : (
            <span className="text-[12.5px] text-muted-foreground">No changes yet</span>
          )}
          <div className="flex flex-wrap gap-2">
            {draft && onDeleteDraft && (
              <Button
                type="button"
                variant="outline"
                className="text-status-hot border-status-hot-soft"
                onClick={onDeleteDraft}
                disabled={deleteDisabled}
              >
                Delete draft
              </Button>
            )}
            <Button type="button" variant="outline" onClick={dirty ? onDiscard : draft ? onClose : onDone}>
              {dirty ? "Discard changes" : draft ? "Close" : "Done"}
            </Button>
            <Button type="submit" form={formId} disabled={!dirty || saving}>
              Save
            </Button>
          </div>
        </>
      ) : (
        <>
          <span className="text-[12.5px] text-muted-foreground">
            {status === "accepted" ? "Accepted quotes are locked." : "Edits save to this quote until it is accepted."}
          </span>
          <Button type="button" variant="outline" onClick={onClose}>
            Close
          </Button>
        </>
      )}
    </div>
  );
}
